import { Button, Form, Header } from "semantic-ui-react";
import { CREATE_USER } from "../graphQueries";
import { useState, useContext } from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

import { AuthContext } from "../AuthContext";

const Invite = () => {
  const { loginContext } = useContext(AuthContext);
  const [sending, setSending] = useState(false);
  const [sendDisabled, setDisabled] = useState(true);
  const [userObj, setUserObj] = useState({
    fullName: "",
    email: "",
    phone: "",
    role: "Attorney",
    isInvite: true,
    invitorName: loginContext.fullName,
    preferredReporterId: loginContext.userId,
  });

  const handleChangeFieldString = (e, data) => {
    setDisabled(false);
    let obj = { ...userObj };
    let key = data.id;
    let value = data.value;
    Object.assign(obj, { [key]: value });
    setUserObj(obj);
  };

  const handleSend = () => {
    setSending(true);
    setDisabled(true);
    if (!userObj.fullName || !userObj.email) {
      setSending(false);
      setDisabled(false);
      toast.error("Please fill out all required fields.");
      return;
    }
    createUser({ variables: userObj });
  };

  const [createUser] = useMutation(CREATE_USER, {
    onCompleted: (result) => handleCreateUser_Result(result),
    onError: (error) => handleCreateUser_Error(error),
  });

  const handleCreateUser_Result = (result) => {
    if (result.createUser.status === "succeeded") {
      toast.success("User created successfully.");
      setSending(false);
      resetState();
    } else {
      toast.error("Error creating user.");
      setSending(false);
      resetState();
    }
  };

  const handleCreateUser_Error = (error) => {
    toast.error(error.message);
    resetState();
  };

  const resetState = () => {
    setTimeout(() => {
      setDisabled(true);
      setSending(false);
    }, 3000);
  };

  return (
    <div
      style={{
        width: "100vw",
        overflow: "auto",
        backgroundColor: "#F1F1F1",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 0,
        margin: 0,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          background: "white",
          maxWidth: "100%",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          padding: "2.5rem 2.5rem",
        }}
      >
        <Header
          as="h1"
          content="Invite User"
          subheader="Add someone you know to the Stenexus platform. They will receive a link to login."
        />
        <div
          style={{
            backgroundColor: "#F1F1F1",
            padding: 20,
            borderRadius: 20,
            marginBottom: 20,
            boxShadow: "0 3px 3px rgba(0,0,0,0.12)",
            maxWidth: 500,
          }}
        >
          <Header
            as="h4"
            style={{ textAlign: "center", marginBottom: 18 }}
            content='Users added via this form will be entered as "Attorney" users.'
          />
          <Form size="large">
            <Form.Input
              required
              id="fullName"
              value={userObj.fullName}
              label="Recipient Name"
              placeholder="e.g. Example Attorney, esq."
              onChange={handleChangeFieldString}
            />
            <Form.Input
              required
              id="email"
              value={userObj.email}
              label="Recipient Email"
              placeholder="e.g. attorney@example.com"
              onChange={handleChangeFieldString}
            />
          </Form>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 20,
          background:
            "linear-gradient(to top, rgba(241,241,241,0.98) 80%, rgba(241,241,241,0.0))",
          padding: "1.5rem 0",
          display: "flex",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 300,
            pointerEvents: "auto",
            padding: "0 2rem",
          }}
        >
          <Button
            icon="send"
            content="Send Invite"
            positive
            size="large"
            disabled={sendDisabled}
            loading={sending}
            onClick={handleSend}
            style={{ marginTop: 10 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Invite;
